import React from 'react';
import { Select } from 'tea-component';
import MultipleDropSelect from './MultipleDropSelect';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import useLanguage from '@op/hooks/useLanguage';
import './index.scss';

export default function ReportFilter({
  confirm,
  data,
  language,
  setLanguage,
  hasLanguage,
  filterDateType,
  pageName,
  defaultValue,
  dropdownRef,
  options,
}: {
  data: any;
  confirm: (value: any) => void;
  language: any;
  setLanguage?: (value: any) => void;
  hasLanguage?: boolean;
  filterDateType: string;
  pageName?: string;
  defaultValue?: any;
  dropdownRef?: React.Ref<any>;
  options: Array<{ text: string; value: string }> | null;
}) {
  const { formatMessage } = useLanguage(); 
  return (
    <div className="dbo-ai-insight-filter">
      <MultipleDropSelect
        reportInsightConfig={data}
        type={filterDateType as any}
        handleReportChange={(report) => {
          buriedBtnPoint('ChangeDate', pageName);
          confirm(report);
        }}
        handleInit={(report) => {
          confirm(report);
        }}
        defaultValue={defaultValue}
        ref={dropdownRef}
      ></MultipleDropSelect>
      {hasLanguage && options && (
        <Select
          appearance="button"
          className="dbo-gpt-language-select"
          options={options}
          value={language}
          matchButtonWidth
          onChange={(value) => {
            buriedBtnPoint('ChangeLanguage', pageName);
            setLanguage?.(value);
          }}
          button={(option) => (
            <div className="select-button">
              <div className="select-button-text">
                {formatMessage({ id: 'Language' })}
              </div>
              <div className="dbo-select-flex">{option?.text}</div>
            </div>
          )}
        />
      )}
    </div>
  );
}
